import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deletePersonaResearch } from '../api/gwi-research.api';
import { GWI_RESEARCH_QUERY_KEYS, type GwiResearchCategory } from '../api/query-keys';

export const useDeletePersonaResearch = (personaId: string, category?: GwiResearchCategory) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deletePersonaResearch(personaId, id),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: GWI_RESEARCH_QUERY_KEYS.history(personaId, category),
      });
    },
  });
};
